module.exports = __webpack_public_path__ + "static/media/pie-chart.1e256b16.svg";